import messages from '../../locale/messages';

const validate = values => {

  const errors = {}

  if (!values.oldPassword && values.registeredType === 'email') {
    errors.oldPassword = messages.required;
  } else if (values && values.oldPassword && values.oldPassword.toString().trim() == '') {
    errors.oldPassword = messages.required;
  }

  if (!values.newPassword) {
    errors.newPassword = messages.required;
  } else if (values && values.newPassword && values.newPassword.toString().trim() == '') {
    errors.newPassword = messages.required;
  } else if (values.newPassword.length < 8) {
    errors.newPassword = messages.passwordError3;
  }

  if (!values.confirmPassword) {
    errors.confirmPassword = messages.required;
  } else if (values && values.confirmPassword && values.confirmPassword.toString().trim() == '') {
    errors.confirmPassword = messages.required;
  } else if (values.confirmPassword.length < 8) {
    errors.confirmPassword = messages.passwordError5;
  }

  return errors
}

export default validate